import PicklistMetadata from "../PicklistMetadata";

// The enclosing location: the OTHER locations of the SAME source.
//
// Scoped by ${enterpriseComponent:SourceUSID}, which resolves against the record being edited rather
// than the session -- a location may only nest inside its own source's tree, and no session token
// could express "this row's source". The record itself is dropped from its own options so it cannot
// become its own parent, and the list is drawn indented because a flat one cannot show that a schema
// sits inside a database.
class LocationParentPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "LocationParent";
        this.bounded = true;
        this.enterpriseComponent = "Location";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        // eslint-disable-next-line no-template-curly-in-string
        this.searchSpecification = {"SourceUSID": "${enterpriseComponent:SourceUSID}"};
        this.sortSpecification = {"Name": "ASC"};
        this.static = false;
        this.typeField = "Name";
        this.typeValue = "USID";
        this.typeValue2 = null;
        this.visibilityType = null;
        this.excludeCurrentRecordValue = true;
        this.hierarchical = true;
        this.hierarchyParentField = "ParentUSID";
        // A name alone does not place a location -- PUBLIC under two databases is two different
        // locations -- so the type is appended.
        this.secondaryDisplayField = "LocationType";
        // A top-level location has no parent, and that has to be expressible.
        this.allowNoSelection = true;
        this.allowNoSelectionValue = null;
        this.allowNoSelectionDisplayValue = "None (top level)";
    }
}

export default LocationParentPicklistMetadata;
